export default __webpack_public_path__ + "static/media/signout-icon.03f8aebd.svg";